import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHFrBodyHowitWorks from "./Components/BodyFrHowitWorks";

class CHFrHowitWorks extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHFrBodyHowitWorks />
        <Footer />
      </>
    );
  }
}

export default CHFrHowitWorks;
